{**********************************************************************************
 * Copyright (C) 1990-2024 Systematic Marketing Ltd (SMXi Software)
 *
 * All code contained within this file is copyrighted and may only be used by
 * third parties with written permission from Systematic Marketing Ltd.
 *
 * For permissions, please contact us at: info@smxi.com
 * Visit our website for more information: https://smxi.com/codecopyright.html
 **********************************************************************************}

// *****************************************************************************//
// ******* THIS IS TO SHARE IN ANY CLIENT (WEB/DESKTOP) APPLICATIONS     *******//
//******** DO NOT USE IN SERVER APPS                                     *******//
// *****************************************************************************//

unit SMX.Auth.Shared;

interface

uses
  Sphinx.Consts;

{$SCOPEDENUMS ON}


{$IFNDEF APP_SERVER}
Type
//These are equivalents to SMX.Auth.Server, but are a cut down list
TUserScope = (
    None,
    ReadOnly,
    Customer,
    User,
    Administrator,
    SuperUser
  );

   TUserStatus = (Pending, Active, InActive, Blocked);
{$ENDIF}

const

  TOKEN_TYPE_ACCESS = 'access_token';
  TOKEN_TYPE_ID = 'id_token';

  CLAIM_FIRSTNAME = JwtClaimNames.GivenName; // 'given_name';
  CLAIM_LASTNAME = JwtClaimNames.FamilyName;
  CLAIM_FULLNAME = JwtClaimNames.Name; // 'name';

  //This is value in the JWT that maps to the UserId in the Sphinx User Table (a lowercase GUID)
  CLAIM_USER_ID = 'sub';

  //This is the value that maps to the Internal Id (Integer)
  CLAIM_PERSONID = 'personid';

  { TODO : Check not used and then remove }
  CLAIM_USER_INTERNAL_ID = CLAIM_PERSONID;


  CLAIM_DATA_COMPLETE = 'datacomplete';
  CLAIM_LOCATIONTYPE = 'locationtype';
  CLAIM_SCOPE = 'scope';
  CLAIM_ROLE = 'role';
  CLAIM_TENANT_ID = 'tenant-id';  //DO NOT CHANGE THIS IS USED BY XData!!!//
  CLAIM_TENANT_KIND = 'tenant-kind';
  CLAIM_ORGANISATION_ID = 'org-id';
  CLAIM_ORGANISATION_NAME = 'org-name';
  CLAIM_ORGANISATION_TENANT_ID = 'org-tenant-id';

  ORGANISATION_NOT_CREATED = 'not-created';
  ORGANISATION_SETUP_PENDING = 'setup-pending';
  ORGANISATION_MULTI_TENANT = 'multi-tenant';

  HEADER_TENANT_ID = 'tenant-id';

  //This is added to the Id Token by Sphinx as "email"
  CLAIM_EMAIL = 'email';

  SCOPE_NONE = 'None';
  SCOPE_READ_ONLY = 'ReadOnly';
  SCOPE_CUSTOMER = 'Customer';
  SCOPE_USER = 'User';
  SCOPE_ADMIN = 'Administrator';
  SCOPE_SUPERUSER = 'SuperUser';
  SCOPE_ALL_USERS = SCOPE_USER + ',' +  SCOPE_ADMIN + ',' +  SCOPE_SUPERUSER;

  {$IFNDEF APP_SERVER}
  USER_SCOPES: array [TUserScope] of string = (
    'None',
    'ReadOnly',
    'Customer',
    'User',
    'Administrator',
    'SuperUser'
  );
{$ENDIF}

  YesNo: array[Boolean] of string = ('No', 'Yes');

{$IFNDEF APP_SERVER}
function IsValidScope(const Value: string): Boolean;
function StrToUserScope(const Value: string): TUserScope;
{$ENDIF}

implementation

{$IFNDEF APP_SERVER}
uses System.Rtti;

function IsValidScope(const Value: string): Boolean;
var I: TUserScope;
begin
  result := False;
  for I := Low(TUserScope) to High(TUserScope) do
  begin
    if USER_SCOPES[I] = Value then
       Exit(True);
  end;
end;

function StrToUserScope(const Value: string): TUserScope;
begin
  Result := TRttiEnumerationType.GetValue<TUserScope>(Value);
end;
{$ENDIF}

{$SCOPEDENUMS OFF}

end.
